import React from "react";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

export default class SelectInput extends React.Component {

    constructor (props){
        super(props);

        this.selectRef = React.createRef();
        this.state = {
            value: this.props.value ? this.props.value : [],
            hide: true
        }
        this.selectRef = React.createRef();

        this.options = []
    }

    getValue(){
        let value = this.selectRef.current.state.value;
        if (Array.isArray(value) == false) return [value];
        return value;
    }

    componentDidMount(){
        this.options = this.props.options;
        this.setState({});
    }


    handleChange (selectedOption) {
        this.setState({value: selectedOption });
        this.props.onChange(selectedOption);
      };

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.setState({value: this.props.value})
        }
      }

    render (){

        const animatedComponents = makeAnimated();
        const arrow = this.props.hidable == true ? '  ᐁ' : '';

        const customStyles = {
            multiValueLabel: (provided, state) => ({
              ...provided,
              width: '100%',
              'white-space': 'break-spaces',
              borderBottom: '1px dotted pink',
            })
        };

        return ( 
        <div style={mainClass}>
            <div
                onClick={() => 
                    this.setState({hide: !this.state.hide})} 
                style={name}>
                {this.props.name + arrow}</div>

            <div style={{display: this.props.hidable == true && this.state.hide == true ? 'none' : 'block'}}>
                <Select ref={this.selectRef} key={Math.random()}
                    style={{ width: '300px' }} 
                    styles={customStyles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    onChange={this.handleChange.bind(this)}
                    defaultValue={[]}
                    value={this.state.value}
                    isMulti={this.props.isMulti}
                    options={this.options}
                />
            </div>
        </div>
        )
    }


}

const mainClass = {
    padding: '5px',
    width: '300px'
}

const name = {
    
}
